export function isIE11() {
  if (typeof window === 'undefined') {
    return false
  }

  return (
    !!(window as any).MSInputMethodContext && !!(document as any).documentMode
  )
}
